import styled from '@emotion/styled'
import React from 'react'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export interface TheWestLogoProps {
    className?: string
    logoWidth?: number
    logoHeight?: number | undefined
}

const StyledImg = styled('img')<TheWestLogoProps>({}, (props) => ({
    // IE11 and some android browsers requires a height and width to render correctly
    width: props.logoWidth ? calcRem(props.logoWidth) : undefined,
    display: 'block',
}))

const homeOfGrandFinal = require('./images/TheWestHomeOfGrandFinalLogo.png')

export const TheWestHomeOfGrandFinalLogo: React.FC<TheWestLogoProps> = ({
    className,
    logoWidth,
}) => (
    <StyledImg
        className={className ? className : undefined}
        src={homeOfGrandFinal}
        logoWidth={logoWidth}
        alt="The West Australian Logo Swan - Grand Final Theme"
    />
)
TheWestHomeOfGrandFinalLogo.displayName = 'TheWestHomeOfGrandFinalLogo'
